// src/hooks/useConfig.js - React hook to access configuration
import { siteConfig } from '../config/siteConfig';
import { themeConfig } from '../config/themeConfig';
import { apiConfig } from '../config/apiConfig';

export const useConfig = () => {
  return {
    site: siteConfig,
    theme: themeConfig,
    api: apiConfig
  };
};